import { IConnection } from "@gtmhub/connectors/models";
import { IDataSourceEntity } from "@gtmhub/insights";
import { isLookerBlueprint, LookerInsightSelectorService } from "@gtmhub/looker";
import { IComponentOptions, IPromise } from "angular";

export class SelectEntityFromListButtonCtrl {
  static $inject = ["LookerInsightSelectorService"];

  public blueprintName: string;
  public connections: IConnection[];
  public onSelectFromList: () => void;
  public onEntitySelected: (args: { entity: IDataSourceEntity }) => void;

  constructor(private lookerInsightSelectorService: LookerInsightSelectorService) {}

  public onClick(): IPromise<void> | void {
    if (!isLookerBlueprint(this.blueprintName)) {
      return this.onSelectFromList();
    }

    const lookerConnections = this.connections.filter((c) => Boolean(c.id));
    if (lookerConnections.length === 0) {
      return this.onSelectFromList();
    }

    return this.lookerInsightSelectorService
      .openBuildInsightModal({
        connections: lookerConnections,
        blueprintName: this.blueprintName,
      })
      .then((entity?: IDataSourceEntity): void => {
        if (entity) {
          this.onEntitySelected({ entity });
        }
      });
  }
}

export const SelectEntityFromListButtonComponent: IComponentOptions = {
  controller: SelectEntityFromListButtonCtrl,
  templateUrl: require("./select-entity-from-list-button.jade"),
  bindings: {
    blueprintName: "@",
    connections: "<",
    onSelectFromList: "&",
    onEntitySelected: "&",
  },
};
